const elements = { '__ignore': [] };

$('#fillFilter').append(generateSelect());
$('#filterSection').css({ display: 'block' });

function generateSelect() {
    const rows = $('#wsEventTable tr');
    const types = [];

    for (let i = 0; i < rows.length; i++) {
        const el = rows.eq(i);
        const tds = el.find('td');

        if (el.hasClass('workshop-ignore')) {
            elements.__ignore.push(el);
        }

        if (tds.length >= 3) {
            const type = tds.eq(2).find('.workshop-type').text().trim();
            if (type && types.indexOf(type) === -1) {
                types.push(type);
            }
            if (!elements.hasOwnProperty(type)) {
                elements[type] = [];
            }
            elements[type].push(el);
        }
    };

    const select = $('<select>');
    select.append(createOption('', 'Show All'));

    types.sort().forEach(a => {
        select.append(createOption(a));
    });

    select.on('change', (e) => {
        const type = e.target.value;
        show(type);
    });

    return select;
}

function createOption(value, text) {
    return $(`<option value="${value}">${text || value}</option>`);
}

function show(v) {
    for (let key in elements) {
        if (v === '' || key == v) {
            elements[key].forEach(function (el) {
                el.removeClass('hidden').addClass('visible');
            });
        } else {
            elements[key].forEach(function (el) {
                el.addClass('hidden').removeClass('visible');
            });
        }
    }

    hideShowStates();
}

function hideShowStates() {
    const states = $('.state-body');
    states.show();

    states.each(function (i, el) {
        var tr = $(el).find('tr:visible');

        if (tr.length <= 1) {
            $(el).hide();
        } else {
            stripe(el);
        }
    });
}

function stripe(tableBody) {
    $(tableBody).find('tr.visible').removeClass('js-striped').filter((i, el) => !!(i % 2)).addClass('js-striped');
}